import { decodeCountryTaxType } from '../../../utils/encodeDecodeCTT';

export const countryCodeGetter = ({ formik }: any) =>
  decodeCountryTaxType(formik.values.countryTaxType).countryCode;
